<template>
  <div>
    <div class="header">
      <b-alert variant="info" :show="message != null">{{message}}</b-alert>
      <b-alert variant="danger" :show="error != null">{{error}}</b-alert>
    </div>
    <b-container fluid>
      <div class="p-2 mb-4 border-bottom border-info">
        <h4 class="text-info font-italic">
          <strong><i class="fas fa-address-card"></i> 参加者
          一覧</strong>
          <span class="ml-2"><b-btn size="sm" variant="info" @click="refreshItems"><i class="fas fa-sync"/> 再読込</b-btn></span>
        </h4>
      </div>
      <b-card no-body>
        <b-list-group>
          <b-list-group-item v-for="member in members" :key="member.user_id">
            <b-btn size="sm" variant="link" @click="goMemberDetail(member)">
              <span>ID番号: <strong>{{member.userNo}}</strong></span>
            </b-btn>
          </b-list-group-item>
        </b-list-group>
      </b-card>
    </b-container>
    <hr>
    <div class="mb-2">
      <b-btn variant="secondary" block @click="$router.push('/usergroups/' + $store.getters.currentUserGroup.groupId + '/top')">
        <span>戻る</span>
      </b-btn>
    </div>
  </div>
</template>

<script>
import { Logger } from 'aws-amplify'

const logger = new Logger('UserGroupMembers')

export default {
  name: 'UserGroupMembers',
  data () {
    return {
      loading: false,
      message: null,
      error: null,
      userNo: null,
      members: []
    }
  },
  computed: {
    currentUserGroup () {
      return this.$store.getters.currentUserGroup || {}
    },
    currentUserGroupId () {
      let curr = this.$store.getters.currentUserGroup
      return curr && curr.groupId
    }
  },
  mounted () {
    this.loadItems()
  },
  methods: {
    loadItems () {
      this.loading = true
      this.message = null
      this.error = null
      return this.$store.dispatch('fetchDailyEnquetesByGroupId', { groupId: this.currentUserGroupId }).then((members) => {
        logger.debug('found users:', members)
        this.loading = false
        this.members = members.sort((a, b) => a.userNo - b.userNo)
      }).catch(err => {
        this.loading = false
        logger.error(err)
        this.error = err.message || err
      })
    },
    refreshItems () {
      return this.loadItems()
    },
    goMemberDetail (member) {
      this.$router.push('/usergroups/' + this.currentUserGroupId + '/users/' + member.user_id)
    }
  }
}
</script>

<style scoped>
.box-shadow {
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, .05);
}
</style>
